import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-bo-page-unauthorized',
  templateUrl: './page-unauthorized.component.html',
  styleUrls: ['./page-unauthorized.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageUnauthorizedComponent {
  @Input() redirectLabel = 'Retour au Notion';
  @Input() redirectUrl = 'https://www.notion.so/wizbii';
}
